import { Modal, Button } from "@components/index";
import AlertImg from "@assets/images/alert-triangle.svg";

export const AssetDocsNeededModal = ({
  messages,
  onClose,
}: {
  messages: string[];
  onClose: () => void;
}) => (
  <Modal show={!!messages.length} onClose={onClose}>
    <div className="flex flex-col items-center text-center">
      <img src={AlertImg} alt="Alert" className="h-12 w-12 md:h-14 md:w-14" />
      <div className="pt-2 text-400 font-bold text-black-100 md:pt-4 md:text-500">
        Documents for assets
      </div>
      <div className="text-100 text-black-54 md:text-300 md:font-light md:text-black-70">
        <div className="flex flex-col gap-y-6 pt-4">
          {messages.map((message, index) => {
            const assetId = message.split("[")[1].split("]")[0];
            const text = message.replace(` [${assetId}]`, "");

            return (
              <div key={index}>
                <div className="pb-2">{text}</div>
                <Button
                  isLink
                  href={`/assets/${assetId}`}
                  variant="primary"
                  height="xxsmall"
                  title="Upload"
                  target="_blank"
                  className="mx-auto mt-1 w-fit"
                />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  </Modal>
);
